import { ShieldCheck, Star, Clock, BadgePercent } from "lucide-react";
import { highlights } from "../mock";

const iconMap = { ShieldCheck, Star, Clock, BadgePercent };

export default function Highlights() {
  return (
    <section className="py-14 bg-[#101318]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {highlights.map((h) => {
            const Icon = iconMap[h.icon] || ShieldCheck;
            return (
              <div key={h.title} className="flex items-center gap-4">
                <span className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-[#e2001a]/15 text-[#ff5a6e] shrink-0">
                  <Icon className="w-6 h-6" />
                </span>
                <div>
                  <p className="font-display font-bold text-white text-lg leading-tight">{h.title}</p>
                  <p className="text-sm text-gray-400">{h.desc}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
